import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const VideoPlayer = () => {
  const [playing, setPlaying] = useState(false);
  const [playing2, setPlaying2] = useState(false);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* VIDEO PLAYERS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Video Players</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Basic Player</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="relative bg-black h-32 rounded flex items-center justify-center">
                <button onClick={() => setPlaying(!playing)} className="w-12 h-12 rounded-full bg-amber-400 hover:bg-amber-300 flex items-center justify-center">{playing ? ("\u23f8") : ("\u25b6")}</button>
              </div>
              <div className="mt-2 flex items-center gap-2"><div className="flex-1 h-1 bg-slate-700 rounded"></div><span className="text-xs text-slate-400">1:30</span></div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`const [playing, setPlaying] = useState(false);

return (
  <div className="relative bg-black rounded">
    <div className="aspect-video flex items-center justify-center">
      <button onClick={() => setPlaying(!playing)} className="w-12 h-12 rounded-full bg-amber-400">
        {playing ? '\u23f8' : '\u25b6'}
      </button>
    </div>
  </div>
);`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Player with Controls</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="bg-slate-800 h-20 rounded flex items-center justify-center text-slate-400">Video Area</div>
              <div className="mt-2 flex items-center justify-between gap-2 p-2 bg-slate-800 rounded">
                <button className="text-amber-400">\u25b6</button>
                <div className="flex-1 h-1 bg-slate-700 rounded"></div>
                <span className="text-xs text-slate-400">2:45</span>
                <button className="text-slate-400">\u26f6</button>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="bg-black rounded overflow-hidden">
  <video controls className="w-full">
    <source src="video.mp4" type="video/mp4" />
  </video>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Playlist Player</label>
            <div className="p-2 bg-slate-950 rounded border border-slate-600 space-y-1">
              <div className="bg-slate-800 h-16 rounded mb-2 flex items-center justify-center text-slate-400">Now Playing</div>
              <div className="text-xs space-y-1">{["Video 1", "Video 2", "Video 3"].map((v, i) => <div key={i} className={`px-2 py-1 rounded cursor-pointer ${i === 0 ? "bg-amber-600 text-white" : "bg-slate-700 text-slate-300"}`}>{v}</div>)}</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex gap-4">
  <video className="flex-1" controls />
  <div className="w-32 space-y-1">
    {playlist.map((v, i) => (
      <button key={i} className={selected === i ? "bg-amber-600" : "bg-slate-700"}>
        {v.title}
      </button>
    ))}
  </div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Custom Quality Selector</label>
            <div className="p-2 bg-slate-950 rounded border border-slate-600">
              <div className="bg-slate-800 h-20 rounded mb-2 flex items-center justify-center text-slate-400">Video Preview</div>
              <div className="flex gap-1 text-xs">{["720p", "1080p", "4K"].map((q, i) => <button key={i} className={`px-2 py-1 rounded ${i === 1 ? "bg-amber-600 text-white" : "bg-slate-700 text-slate-300"}`}>{q}</button>)}</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex gap-1">
  {["720p", "1080p", "4K"].map(q => (
    <button key={q} onClick={() => setQuality(q)} className={selected === q ? "bg-amber-600" : "bg-slate-700"}>
      {q}
    </button>
  ))}
</div>`} />
          </div>
        </div>
      </div>

      {/* ADVANCED PLAYERS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Players</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Embedded Stream</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="bg-gradient-to-br from-amber-900 to-slate-900 h-32 rounded flex items-center justify-center">
                <div className="text-center"><div className="text-3xl mb-1">\ud83d\udd34</div><p className="text-red-400 text-xs font-bold">LIVE</p></div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="relative bg-black rounded overflow-hidden">
  <iframe src="https://stream.example.com" className="w-full aspect-video" />
  <div className="absolute top-2 right-2 px-2 py-1 bg-red-600 text-white text-xs font-bold">
    LIVE
  </div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Picture-in-Picture</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600 relative h-32">
              <div className="w-full h-full bg-slate-800 rounded flex items-center justify-center">Main Video</div>
              <div className="absolute bottom-2 right-2 w-14 h-10 bg-slate-700 rounded border border-slate-600"></div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<video id="main" controls />
<script>
  const video = document.getElementById('main');
  pip_button.onclick = () => video.requestPictureInPicture();
</script>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoPlayer;


